<template>
  <div class="invoice-status-container">
    <div class="invoice-status-pill" :class="invoice.status" data-toggle="tooltip" :title="status_tooltip">
      {{ status_name }}
    </div>
    <div v-if="has_notice" class="invoice-status-notice draft" data-toggle="tooltip" :title="notice_tooltip">
      Con errores
    </div>
  </div>
</template>

<script>
export default {
  props: ["invoice"],
  computed: {
    status_name() {
      const status_names = {
        legacy: 'Antigua',
        draft: 'Borrador',
        pending_publish: 'Publicando',
        error: "Error",
        annulled: 'Anulada',
        published: 'Publicada'
      };

      return status_names[this.invoice.status] || 'N/D';
    },
    status_tooltip() {
      const status_tips = {
        legacy: "Factura antigua. No es necesario aprobarla",
        draft: "Borrador. Es necesario aprobar la factura para emitirla",
        pending_publish: "Pendiente de publicación",
        error: "Error de publicación. Por favor edite la factura para ver los detalles",
        annulled: "Factura anulada tras ser publicada. Ya no se puede editar",
        published: "Publicada. Ya no se puede editar",
      }

      return status_tips[this.invoice.status] || 'N/D';
    },
    verifactu_status() {
      if (!this.invoice) {
        return null;
      }

      return this.invoice.verifactu_status;
    },
    has_notice() {
      if (!this.invoice || this.invoice.status !== 'published') {
        return false;
      }

      const vfactu_status = this.verifactu_status;
      if (!vfactu_status || (vfactu_status.error || false)) {
        return false;
      }

      const registration = vfactu_status.content.transmission.registration || null;
      return (registration == 'REQUIRES_INSPECTION' || registration == 'REQUIRES_CORRECTION');
    },

    notice_tooltip() {
      if (!this.has_notice) {
        return '';
      }

      let validations = this.verifactu_status.content.validations.map((validation) => {
        return `${validation.code} - ${validation.description}`;
      });

      return validations.join(' | ');
    },
    ...mapGetters(['clinic_cfg'])
  }
};
</script>

<style lang="scss">
.invoice-status-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.invoice-status-notice,
.invoice-status-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: var(--theme-color);
  border-radius: 30px;
  border: none;
  margin: 5px;
  font-size: 12px;
  padding: 3px 15px;
  transition: 0.3s;
  font-weight: bold;

  &.draft {
    color: black;
    background: var(--theme-warning);
  }

  &.pending_publish,
  &.annulled {
    opacity: 0.5;
  }

  &.published {
    background: var(--theme-color-attended);
  }

  &.error {
    background: var(--theme-danger);
  }
}
</style>
